"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2225],{

/***/ 36165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ConfirmDialog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31812);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58951);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41796);
/* harmony import */ var _animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59636);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65907);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9671);


// @mui



// components



// ----------------------------------------------------------------------
ConfirmDialog.propTypes = {
    values: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    onSubmit: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};
function ConfirmDialog(param) {
    var values = param.values, isOpen = param.isOpen, onClose = param.onClose, onSubmit = param.onSubmit;
    var title = values.title, content = values.content;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().translate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_animate__WEBPACK_IMPORTED_MODULE_1__/* .DialogAnimate */ .Kl, {
        open: isOpen,
        onClose: onClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "alert-dialog-title",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                id: "alert-dialog-description",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    sx: {
                        mt: 3,
                        mb: 1
                    },
                    children: content
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    py: 2,
                    px: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        onClick: onClose,
                        children: translate("button.disagree")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        type: "submit",
                        variant: "contained",
                        onClick: onSubmit,
                        children: translate("button.agree")
                    })
                ]
            })
        ]
    });
}
// ----------------------------------------------------------------------
PreviewHero.propTypes = {
    cover: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
function PreviewHero(param) {
    var title = param.title, cover = param.cover;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                sx: {
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9,
                    position: "absolute",
                    color: "common.white",
                    pt: {
                        xs: 3,
                        lg: 10
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    variant: "h2",
                    component: "h1",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                sx: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 8,
                    position: "absolute",
                    bgcolor: function(theme) {
                        return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* .alpha */ .Fq)(theme.palette.grey[900], 0.8);
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: "cover",
                src: cover,
                ratio: "16/9"
            })
        ]
    });
}


/***/ }),

/***/ 77251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmptyContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11496);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9671);





// @mui



//
// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        height: "100%",
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.spacing(4, 2)
    };
});
// ----------------------------------------------------------------------
EmptyContent.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    img: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
function EmptyContent(_param) {
    var title = _param.title, description = _param.description, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "title",
        "description"
    ]);
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().translate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RootStyle, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "h6",
                gutterBottom: true,
                children: title || translate("label.nodata")
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "body2",
                sx: {
                    color: "text.secondary"
                },
                children: description
            })
        ]
    }));
}


/***/ }),

/***/ 36239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ SocialShare; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93946);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53597);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46616);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16573);
/* harmony import */ var _Iconify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22554);
/* eslint-disable react/prop-types */ 







function SocialShare(param) {
    var title = param.title, url = param.url;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    if (!url) url = "https://onthibanglaixe.net".concat(asPath);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        {
            name: "Link",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default()), {
                text: url,
                onCopy: function() {
                    return enqueueSnackbar("Copied!");
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    icon: "eva:copy-fill",
                    width: 25,
                    height: 25
                })
            })
        },
        {
            name: "Linkedin",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                url: url,
                title: title || url,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    icon: "eva:linkedin-fill",
                    width: 25,
                    height: 25,
                    color: "#006097"
                })
            })
        },
        {
            name: "Twitter",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                url: url,
                title: title || url,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    icon: "eva:twitter-fill",
                    width: 25,
                    height: 25,
                    color: "#1C9CEA"
                })
            })
        },
        {
            name: "Facebook",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                url: url,
                title: title || url,
                quote: title || url,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    icon: "eva:facebook-fill",
                    width: 25,
                    height: 25,
                    color: "#1877F2"
                })
            })
        }
    ]), SOCIALS = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: SOCIALS.map(function(action) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                "aria-label": action.name,
                color: "default",
                children: action.icon
            }, action.name);
        })
    });
}


/***/ }),

/***/ 74055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LightboxModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92879);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42287);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);






// @mui


// ----------------------------------------------------------------------
function LightboxModalStyles() {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var isRTL = theme.direction === "rtl";
    var ICON_SIZE = 32;
    var ICON_COLOR = theme.palette.grey[600].replace("#", "");
    var getIcon = function(icon) {
        return "url(https://api.iconify.design/carbon/".concat(icon, ".svg?color=%23").concat(ICON_COLOR, "&width=").concat(ICON_SIZE, "&height=").concat(ICON_SIZE, ")");
    };
    var Icon = function(icon) {
        return {
            opacity: 1,
            alignItems: "center",
            display: "inline-flex",
            justifyContent: "center",
            backgroundImage: "unset",
            backgroundColor: "transparent",
            transition: theme.transitions.create("opacity"),
            "&:before": {
                display: "block",
                width: ICON_SIZE,
                height: ICON_SIZE,
                content: getIcon(icon)
            },
            "&:hover": {
                opacity: 0.72
            }
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        styles: {
            "& .ReactModalPortal": {
                "& .ril__outer": {
                    backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.grey[900], 0.96)
                },
                // Toolbar
                "& .ril__toolbar": {
                    height: "auto !important",
                    padding: theme.spacing(2, 3),
                    backgroundColor: "transparent"
                },
                "& .ril__toolbarLeftSide": {
                    display: "none"
                },
                "& .ril__toolbarRightSide": {
                    height: "auto !important",
                    padding: 0,
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    "& li": {
                        display: "flex",
                        alignItems: "center"
                    },
                    "& li:first-of-type": {
                        flexGrow: 1
                    },
                    "& li:not(:first-of-type)": {
                        width: 40,
                        height: 40,
                        justifyContent: "center",
                        marginLeft: theme.spacing(2)
                    }
                },
                // Button
                "& button:focus": {
                    outline: "none"
                },
                "& .ril__toolbarRightSide button": {
                    width: "100%",
                    height: "100%",
                    "&.ril__zoomInButton": Icon("zoom-in"),
                    "&.ril__zoomOutButton": Icon("zoom-out"),
                    "&.ril__closeButton": Icon("close")
                },
                "& .ril__navButtons": {
                    padding: theme.spacing(3),
                    "&.ril__navButtonPrev": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        right: "auto",
                        left: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-right" : "arrow-left")),
                    "&.ril__navButtonNext": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        left: "auto",
                        right: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-left" : "arrow-right"))
                }
            }
        }
    });
}
// ----------------------------------------------------------------------
LightboxModal.propTypes = {
    images: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().array.isRequired),
    photoIndex: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    setPhotoIndex: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
function LightboxModal(_param) {
    var images = _param.images, photoIndex = _param.photoIndex, setPhotoIndex = _param.setPhotoIndex, isOpen = _param.isOpen, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "images",
        "photoIndex",
        "setPhotoIndex",
        "isOpen"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isOpen
    ]);
    var showIndex = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        variant: "subtitle2",
        children: "".concat(photoIndex + 1, " / ").concat(images.length)
    });
    var toolbarButtons = [
        showIndex
    ];
    var customStyles = {
        overlay: {
            zIndex: 9999
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LightboxModalStyles, {}),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                animationDuration: 160,
                nextSrc: images[(photoIndex + 1) % images.length],
                prevSrc: images[(photoIndex + images.length - 1) % images.length],
                onMovePrevRequest: function() {
                    return setPhotoIndex((photoIndex + images.length - 1) % images.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIndex((photoIndex + 1) % images.length);
                },
                toolbarButtons: toolbarButtons,
                reactModalStyle: customStyles
            }, other))
        ]
    });
}


/***/ }),

/***/ 81320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Markdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67849);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(34768);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78462);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97212);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59334);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11496);
/* harmony import */ var highlight_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65907);
/* harmony import */ var _LightboxModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74055);







// markdown plugins

// next

// @mui


//




// ----------------------------------------------------------------------
var MarkdownStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    var isLight = theme.palette.mode === "light";
    var _obj;
    return {
        // List
        "& ul, & ol": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.typography.body1), {
            paddingLeft: theme.spacing(5),
            "& li": {
                lineHeight: 2
            }
        }),
        // Blockquote
        "& blockquote": (_obj = {
            lineHeight: 1.5,
            fontSize: "1.5em",
            margin: "40px auto",
            position: "relative",
            fontFamily: "Roboto, sans-serif",
            padding: theme.spacing(3, 3, 3, 8),
            borderRadius: Number(theme.shape.borderRadius) * 2,
            backgroundColor: theme.palette.background.neutral,
            color: "".concat(theme.palette.text.secondary, " !important")
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
            width: "80%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& p, & span", {
            marginBottom: "0 !important",
            fontSize: "inherit !important",
            fontFamily: "Roboto, sans-serif !important",
            color: "".concat(theme.palette.text.secondary, " !important")
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "&:before", {
            left: 16,
            top: -8,
            display: "block",
            fontSize: "3em",
            content: '"\\201C"',
            position: "absolute",
            color: theme.palette.text.disabled
        }), _obj),
        // Code Block
        "& pre, & pre > code": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.typography.body1), {
            overflowX: "auto",
            whiteSpace: "pre",
            padding: theme.spacing(2),
            color: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "".concat(isLight ? theme.palette.grey[900] : theme.palette.grey[50016], " !important")
        }),
        "& code": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.typography.body1), {
            borderRadius: 4,
            whiteSpace: "pre",
            padding: theme.spacing(0.2, 0.5),
            color: theme.palette.warning[isLight ? "darker" : "lighter"],
            backgroundColor: theme.palette.warning[isLight ? "lighter" : "darker"],
            textWrap: "wrap!important",
            "&.hljs": {
                padding: 0,
                backgroundColor: "transparent"
            }
        }),
        "& .ql-container.ql-snow": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            borderColor: "transparent"
        }, theme.typography.body1), {
            fontFamily: theme.typography.fontFamily
        }),
        "& .ql-editor": {
            "&.ql-blank::before": {
                fontStyle: "normal",
                color: theme.palette.text.disabled
            },
            "& pre.ql-syntax": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.typography.body1), {
                padding: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
                backgroundColor: isLight ? theme.palette.grey[900] : theme.palette.grey[50016]
            })
        }
    };
});
// ----------------------------------------------------------------------
function Markdown(_param) {
    var TOC = function TOC() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            className: "table-of-contents",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    variant: "overline",
                    children: "Mục lục:"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    dense: true,
                    children: toc.map(function(param) {
                        var level = param.level, id = param.id, title = param.title;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                            className: "toc-entry-level-".concat(level),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                href: "#".concat(id),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    primary: title
                                })
                            })
                        }, id);
                    })
                })
            ]
        });
    };
    var other = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
    var toc = [];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timeout = setTimeout(function() {
            highlight_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"].highlightAll */ .Z.highlightAll();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, []);
    var addToTOC = function(_param) {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
        var ref;
        var children = props.children;
        var level = Number((ref = props.node.tagName.match(/h(\d)/)) === null || ref === void 0 ? void 0 : ref.slice(1));
        var id = Date.now();
        if (children && typeof children[0] === "string") {
            id = children[0].toLowerCase().replace(/[^a-z0-9]+/g, "-");
            toc.push({
                level: level,
                id: id,
                title: children[0]
            });
        } else if (level && children && typeof children[0] === "object") {
            /// nested span or strong tag inside h
            var type = children[0].type;
            if (type === "span" || type === "strong") {
                var subChildren = children[0].props.children[0];
                if (subChildren && typeof subChildren === "string") {
                    id = subChildren.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                    toc.push({
                        level: level,
                        id: id,
                        title: subChildren
                    });
                }
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            variant: props.node.tagName
        }, props), {
            style: {
                lineHeight: 2,
                scrollMarginTop: 100
            },
            id: id
        }));
    };
    var components = {
        h1: addToTOC,
        h2: addToTOC,
        h3: addToTOC,
        h4: addToTOC,
        h5: addToTOC,
        h6: addToTOC,
        p: function(_param) /*#__PURE__*/ {
            var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                variant: "body1"
            }, props));
        },
        hr: function(_param) /*#__PURE__*/ {
            var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                sx: {
                    my: 3
                }
            }, props));
        },
        img: function(_param) /*#__PURE__*/ {
            var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageBox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props));
        },
        iframe: function(_param) /*#__PURE__*/ {
            var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                width: "650",
                height: "366",
                style: {
                    maxWidth: "100%"
                }
            }, props));
        },
        a: function(_param) {
            var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, _param);
            return props.href.includes("http") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                target: "_blank",
                rel: "noopener"
            }, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: props.href,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }))
            });
        },
        pre: function(_param) /*#__PURE__*/ {
            var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, [
                "children"
            ]);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                    children: children
                })
            }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MarkdownStyle, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_19__/* .ReactMarkdown */ .D, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                rehypePlugins: [
                    rehype_raw__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z
                ],
                components: components
            }, other)),
            toc.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TOC, {})
                ]
            })
        ]
    });
}
;
// ----------------------------------------------------------------------
function ImageBox(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openLightbox = ref[0], setOpenLightbox = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                alt: props.alt,
                sx: {
                    borderRadius: 0,
                    my: 1.5,
                    width: "auto"
                }
            }, props), {
                onClick: function() {
                    return setOpenLightbox(true);
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LightboxModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                images: [
                    props.src
                ],
                mainSrc: props.src,
                photoIndex: 0,
                setPhotoIndex: 0,
                isOpen: openLightbox,
                onCloseRequest: function() {
                    return setOpenLightbox(false);
                }
            })
        ]
    });
}


/***/ }),

/***/ 37549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ SkeletonSolutionItem; },
/* harmony export */   "bG": function() { return /* binding */ SkeletonCommentItem; },
/* harmony export */   "lW": function() { return /* binding */ SkeletonTableItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);
// @mui


// ----------------------------------------------------------------------
function SkeletonSolutionItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        direction: "row",
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "circular",
                sx: {
                    width: 36,
                    height: 36
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: 70,
                    borderRadius: 1
                }
            })
        ]
    });
}
function SkeletonTableItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        direction: "row",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "text",
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "text",
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "text",
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "text",
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "text",
                sx: {
                    flexGrow: 1
                }
            })
        ]
    });
}
function SkeletonCommentItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        direction: "row",
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "circular",
                sx: {
                    width: 36,
                    height: 36
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: 70,
                    borderRadius: 1
                }
            })
        ]
    });
}


/***/ }),

/***/ 83741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CommentItemWrapper; }
/* harmony export */ });
/* unused harmony export CommentItem */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10633);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(87952);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(15861);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var _components_ConfirmDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36165);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77251);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22554);
/* harmony import */ var _components_Markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81320);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77364);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29050);
/* harmony import */ var _service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(75291);
/* harmony import */ var _utils_formatNumber__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87850);
/* harmony import */ var _CommentNewForm__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79136);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 




















// ----------------------------------------------------------------------
function CommentItemWrapper(param) {
    var comment = param.comment;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().translate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isShowReplies = ref[0], setShowReplies = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 0,
        size: 10,
        value: "%%",
        orders: [
            {
                order: "desc",
                property: "createdAt"
            }
        ],
        filterBys: {
            itemId: comment === null || comment === void 0 ? void 0 : comment.id,
            type: "REPLY"
        }
    }), search = ref1[0], setSearch = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        isLoading: false,
        totalPages: 0,
        numberOfElements: 0,
        comments: []
    }), response = ref2[0], setResponse = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        isShowReplies && loadReplies();
    }, [
        search,
        isShowReplies,
        comment === null || comment === void 0 ? void 0 : comment.replyNo
    ]);
    var loadReplies = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var ref, code, comments, totalPages, numberOfElements;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setResponse((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, response), {
                            isLoading: true
                        }));
                        return [
                            4,
                            (0,_service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_13__/* .findCommentAPI */ .bz)(search)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, comments = ref.data, totalPages = ref.totalPages, numberOfElements = ref.numberOfElements;
                        if (code === "200") setResponse((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, response), {
                            comments: comments,
                            totalPages: totalPages,
                            numberOfElements: numberOfElements,
                            isLoading: false
                        }));
                        else setResponse((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, response), {
                            isLoading: false
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function loadReplies() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowReplies = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                setShowReplies(!isShowReplies);
                setSearch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, search), {
                    page: 0
                }));
                return [
                    2
                ];
            });
        });
        return function handleShowReplies() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function(_, value) {
        setSearch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentItem, {
                comment: comment,
                showReplies: handleShowReplies
            }),
            isShowReplies && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                spacing: 2,
                pl: 5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        spacing: 2,
                        children: [
                            response.comments.map(function(c) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplyItem, {
                                    comment: c
                                }, c.id);
                            }),
                            response.isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_9__/* .SkeletonCommentItem */ .bG, {}) : response.numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                title: " ",
                                description: translate("label.noComment")
                            })
                        ]
                    }),
                    response.numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        alignItems: "center",
                        my: 1.5,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            count: response.totalPages,
                            variant: "text",
                            page: search.page + 1,
                            onChange: handleChangePage
                        })
                    })
                ]
            })
        ]
    });
}
function CommentItem(param) {
    var comment = param.comment, showReplies = param.showReplies;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().translate;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)();
    var isAuthenticated = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().isAuthenticated;
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), openReply = ref[0], setOpenReply = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(comment === null || comment === void 0 ? void 0 : comment.likeNo), likeNo = ref1[0], setLikeNo = ref1[1];
    var handleLike = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                if (!isAuthenticated) {
                    enqueueSnackbar(translate("label.signinToGPLX"), {
                        variant: "error"
                    });
                    return [
                        2
                    ];
                }
                setLikeNo(likeNo + 1);
                (0,_service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_13__/* .updateLikeAPI */ .Sz)(comment === null || comment === void 0 ? void 0 : comment.id);
                return [
                    2
                ];
            });
        });
        return function handleLike() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentContent, {
                comment: comment
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        color: "inherit",
                        variant: "text",
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            icon: "iconamoon:like-light",
                            sx: {
                                height: 18,
                                width: 18
                            }
                        }),
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, theme.typography.body2),
                        onClick: handleLike,
                        children: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_14__/* .fShortenNumber */ .v1)(likeNo)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        color: "inherit",
                        variant: "text",
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            icon: "humbleicons:chat",
                            sx: {
                                height: 18,
                                width: 18
                            }
                        }),
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, theme.typography.body2),
                        onClick: showReplies,
                        children: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_14__/* .fShortenNumber */ .v1)(comment === null || comment === void 0 ? void 0 : comment.replyNo)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        color: "inherit",
                        variant: "text",
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            icon: "bi:reply",
                            sx: {
                                height: 18,
                                width: 18
                            }
                        }),
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, theme.typography.body2),
                        onClick: function() {
                            return setOpenReply(!openReply);
                        },
                        children: translate("button.reply")
                    })
                ]
            }),
            openReply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentNewForm__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                itemId: comment === null || comment === void 0 ? void 0 : comment.id,
                type: "REPLY"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {})
        ]
    });
}
var ReplyItem = function(param) {
    var comment = param.comment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentContent, {
                comment: comment
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {})
        ]
    });
};
var CommentContent = function(param) {
    var comment = param.comment;
    var ref, ref1, ref2, ref3, ref4;
    var user = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().user;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().translate;
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var search = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }).search;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), open = ref5[0], setOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), editable = ref6[0], setEditable = ref6[1];
    var confirmDeleteItem = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_13__/* .deleteCommentAPI */ .$s)(comment === null || comment === void 0 ? void 0 : comment.id)
                        ];
                    case 1:
                        resp = _state.sent();
                        setOpen(false);
                        if (resp.code === "200") {
                            enqueueSnackbar(translate("message.deleteSuccess"), {
                                variant: "success"
                            });
                            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_12__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, search)));
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function confirmDeleteItem() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEdit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                setEditable(true);
                return [
                    2
                ];
            });
        });
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                direction: "row",
                spacing: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/user/".concat(comment === null || comment === void 0 ? void 0 : (ref = comment.createdBy) === null || ref === void 0 ? void 0 : ref.id),
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    alt: comment === null || comment === void 0 ? void 0 : (ref1 = comment.createdBy) === null || ref1 === void 0 ? void 0 : ref1.displayName,
                                    src: comment === null || comment === void 0 ? void 0 : (ref2 = comment.createdBy) === null || ref2 === void 0 ? void 0 : ref2.photoURL,
                                    sx: {
                                        width: 36,
                                        height: 36,
                                        cursor: "pointer"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/user/".concat(comment === null || comment === void 0 ? void 0 : (ref3 = comment.createdBy) === null || ref3 === void 0 ? void 0 : ref3.id),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            variant: "subtitle2",
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: comment === null || comment === void 0 ? void 0 : (ref4 = comment.createdBy) === null || ref4 === void 0 ? void 0 : ref4.displayName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        variant: "caption",
                                        sx: {
                                            color: "text.disabled"
                                        },
                                        children: comment === null || comment === void 0 ? void 0 : comment.createdAt
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        direction: "row",
                        spacing: 1,
                        children: [
                            (user === null || user === void 0 ? void 0 : user.id) === (comment === null || comment === void 0 ? void 0 : comment.createdBy.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                onClick: handleEdit,
                                size: "small",
                                color: "primary",
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    icon: "circum:edit",
                                    sx: {
                                        height: 18,
                                        width: 18
                                    }
                                }),
                                children: translate("button.edit")
                            }),
                            (user === null || user === void 0 ? void 0 : user.id) === (comment === null || comment === void 0 ? void 0 : comment.createdBy.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                size: "small",
                                color: "error",
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    icon: "octicon:trash-16",
                                    sx: {
                                        height: 18,
                                        width: 18
                                    }
                                }),
                                onClick: function() {
                                    return setOpen(true);
                                },
                                children: translate("button.delete")
                            })
                        ]
                    })
                ]
            }),
            editable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentNewForm__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                id: comment === null || comment === void 0 ? void 0 : comment.id,
                content: comment === null || comment === void 0 ? void 0 : comment.description,
                isEdit: true,
                setEditable: setEditable
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ql-snow",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "ql-editor",
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: comment === null || comment === void 0 ? void 0 : comment.description
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConfirmDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                values: {
                    title: translate("message.dialogDeleteTitle"),
                    content: translate("message.dialogDeleteContent")
                },
                onClose: function() {
                    return setOpen(false);
                },
                isOpen: open,
                onSubmit: confirmDeleteItem
            })
        ]
    });
};


/***/ }),

/***/ 79136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentNewForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95496);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(31812);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11496);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _components_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54397);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77364);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33599);
/* harmony import */ var _service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75291);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 



















// ----------------------------------------------------------------------
var RootStyles = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(1),
        borderRadius: Number(theme.shape.borderRadius),
        backgroundColor: theme.palette.background.neutral
    };
});
// ----------------------------------------------------------------------
function CommentNewForm(param) {
    var itemId = param.itemId, type = param.type, isEdit = param.isEdit, id = param.id, content = param.content, setEditable = param.setEditable;
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().translate;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    //name field
    var description = "description".concat(itemId || id).concat(type);
    var isAuthenticated = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().isAuthenticated;
    var search = (0,_redux_store__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }).search;
    var NewItemSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, description, yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required(translate("validation.required"))));
    var defaultValues = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, description, content || "");
    }, [
        id
    ]);
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_1__/* .yupResolver */ .X)(NewItemSchema),
        defaultValues: defaultValues
    });
    var handleSubmit = methods.handleSubmit, reset = methods.reset, isSubmitting = methods.formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(data) {
            var request, resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToGPLX"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        request = {
                            id: id,
                            itemId: itemId,
                            type: type,
                            description: data[description]
                        };
                        resp = null;
                        if (!isEdit) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_11__/* .updateCommentAPI */ .gP)(request)
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,_service_blog_blog_comment_service__WEBPACK_IMPORTED_MODULE_11__/* .createCommentAPI */ .GQ)(request)
                        ];
                    case 3:
                        resp = _state.sent();
                        _state.label = 4;
                    case 4:
                        if (resp.code === "200") {
                            reset();
                            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_9__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, search), {
                                page: 0
                            })));
                            if (isEdit) {
                                setEditable(false);
                                enqueueSnackbar(translate("message.updateSuccess"));
                            } else enqueueSnackbar(translate("message.createSuccess"));
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyles, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .FormProvider */ .RV, {
            methods: methods,
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .RHFEditor */ .LM, {
                    name: description,
                    simple: true,
                    sx: {
                        "& .ql-editor": {
                            height: 90,
                            minHeight: 80
                        },
                        "& .ql-toolbar.ql-snow": {
                            padding: "0px 8px"
                        },
                        "& .ql-formats": {
                            marginRight: "0px!important"
                        },
                        "& .ql-container.ql-snow": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, theme.typography.body1)
                    },
                    placeholder: translate("label.writeComment")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    direction: "row",
                    spacing: 2,
                    justifyContent: "flex-end",
                    children: [
                        isEdit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            color: "inherit",
                            type: "button",
                            variant: "text",
                            onClick: function() {
                                return setEditable(false);
                            },
                            children: translate("button.close")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            type: "submit",
                            variant: "contained",
                            loading: isSubmitting,
                            children: translate("button.comment")
                        })
                    ]
                })
            ]
        })
    });
}


/***/ })

}]);